import React from 'react';
import ReactDOM from 'react-dom';
import LandingPage from '../pages/LandingPage';
import "../../less/app.less";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Provider } from 'react-redux';
import store from '../redux/store';
import { PrivateRoute } from './PrivateRoute';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import Home from '../pages/Home';
import Dashboard from '../pages/Dashboard';
import Reports from '../pages/Reports';
import PlatformUsersManagement from '../pages/PlatformUsersManagement';
import AccountConfig from '../pages/AccountConfig';
import Cashier from '../pages/Cashier';
import { ConfigProvider } from 'antd';
import Consultations from '../pages/Consultations';
import Departments from '../pages/Departments';
import Companies from '../pages/Companies';
import Laboratoire from '../pages/Laboratoire';
import CompanyReports from '../pages/CompanyReports';
import PatientPage from '../pages/PatientPage';
import Imagerie from '../pages/Imagerie';
import Facturation from '../pages/Facturation';
import Audio from '../pages/Audio';
import Visio from '../pages/Visio';
import Vaccin from '../pages/Vaccin';
import Drug from '../pages/Drug';
import Evolution from '../pages/Evolution';
import Conclusion from '../pages/Conclusion';
import CheckResult from './CheckResult';
import Spirometrie from '../pages/Spirometrie';
import HrView from '../pages/HrView';
import Hr from '../pages/Hr';
import Ecg from '../pages/Ecg';
import Validated from '../pages/Validated';
import History from '../pages/History';
import Certificates from '../pages/Certificates';
import Appointments from '../pages/Appointments';
import VaPlanning from '../pages/VaPlanning';
import EmployeeId from '../pages/EmployeeId';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function App() {
  return /*#__PURE__*/_jsx(ConfigProvider, {
    theme: {
      token: {
        colorPrimary: '#103767',
        colorLink: '#7B0001',
        borderRadius: '18px'
      }
    },
    children: /*#__PURE__*/_jsx(Router, {
      children: /*#__PURE__*/_jsxs(Routes, {
        children: [/*#__PURE__*/_jsx(Route, {
          exact: true,
          path: "/",
          element: /*#__PURE__*/_jsx(PrivateRoute, {
            children: /*#__PURE__*/_jsx(LandingPage, {})
          })
        }), /*#__PURE__*/_jsx(Route, {
          path: "/bonjour",
          element: /*#__PURE__*/_jsx(LandingPage, {})
        }), /*#__PURE__*/_jsx(Route, {
          path: "/company/:company_id",
          element: /*#__PURE__*/_jsx(CompanyReports, {})
        }), /*#__PURE__*/_jsx(Route, {
          path: "/check/:id",
          element: /*#__PURE__*/_jsx(CheckResult, {})
        }), /*#__PURE__*/_jsx(Route, {
          path: "/employeeinfo/:id",
          element: /*#__PURE__*/_jsx(EmployeeId, {})
        }), /*#__PURE__*/_jsxs(Route, {
          path: "home",
          element: /*#__PURE__*/_jsx(Home, {}),
          children: [/*#__PURE__*/_jsx(Route, {
            path: "/home",
            element: /*#__PURE__*/_jsx(Dashboard, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "/home/:userid",
            element: /*#__PURE__*/_jsx(Dashboard, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "patient/:pid",
            element: /*#__PURE__*/_jsx(PatientPage, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "dashboard",
            element: /*#__PURE__*/_jsx(Dashboard, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "hrview",
            element: /*#__PURE__*/_jsx(HrView, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "cashier",
            element: /*#__PURE__*/_jsx(Cashier, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "consultations",
            element: /*#__PURE__*/_jsx(Consultations, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "laboratoire",
            element: /*#__PURE__*/_jsx(Laboratoire, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "imagerie",
            element: /*#__PURE__*/_jsx(Imagerie, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "spiro",
            element: /*#__PURE__*/_jsx(Spirometrie, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "audio",
            element: /*#__PURE__*/_jsx(Audio, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "ecg",
            element: /*#__PURE__*/_jsx(Ecg, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "visio",
            element: /*#__PURE__*/_jsx(Visio, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "vaccin",
            element: /*#__PURE__*/_jsx(Vaccin, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "hr",
            element: /*#__PURE__*/_jsx(Hr, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "drug",
            element: /*#__PURE__*/_jsx(Drug, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "validated",
            element: /*#__PURE__*/_jsx(Validated, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "evolution",
            element: /*#__PURE__*/_jsx(Evolution, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "conclusion",
            element: /*#__PURE__*/_jsx(Conclusion, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "history",
            element: /*#__PURE__*/_jsx(History, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "certs",
            element: /*#__PURE__*/_jsx(Certificates, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "appointments",
            element: /*#__PURE__*/_jsx(Appointments, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "departments",
            element: /*#__PURE__*/_jsx(Departments, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "companies",
            element: /*#__PURE__*/_jsx(Companies, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "accountconfig",
            element: /*#__PURE__*/_jsx(AccountConfig, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "reports",
            element: /*#__PURE__*/_jsx(Reports, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "facturation",
            element: /*#__PURE__*/_jsx(Facturation, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "users",
            element: /*#__PURE__*/_jsx(PlatformUsersManagement, {})
          }), /*#__PURE__*/_jsx(Route, {
            path: "vaplanning",
            element: /*#__PURE__*/_jsx(VaPlanning, {})
          })]
        })]
      })
    })
  });
}
export default App;
if (document.getElementById('app')) {
  ReactDOM.render(/*#__PURE__*/_jsx(Provider, {
    store: store,
    children: /*#__PURE__*/_jsx(App, {})
  }), document.getElementById('app'));
}